import { Outlet } from "react-router-dom";

type Props = {};

const Report = (props: Props) => {
  return <Outlet />;
};

export default Report;
